import { useCallback, useLayoutEffect, useRef, useState } from 'react';

export function useElementHeightBySelector(selector: string): number {
    const [height, setHeight] = useState(0);
    const observer = useRef<ResizeObserver | null>(null);

    const updateHeight = useCallback(() => {
        const el = document.querySelector(selector);
        if (!el) return;

        const newHeight = el.getBoundingClientRect().height;
        setHeight(newHeight);
    }, [selector]);

    useLayoutEffect(() => {
        updateHeight();

        observer.current = new ResizeObserver(updateHeight);
        const el = document.querySelector(selector);
        if (el) {
            observer.current.observe(el);
        }

        return () => {
            observer.current?.disconnect();
            observer.current = null;
        };
    }, [selector, updateHeight]);

    return height;
}
